<template>
    <div>
        <b-form id="searchForm">
            <b-input name="search" v-model="searchString" id="search" type="text" class="form-control"
                     placeholder="Search"
                     aria-label="Search" aria-describedby="basic-addon2" @keyup="search">
            </b-input>
        </b-form>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "SearchComponent",
    data() {
        return {
            searchString: ''
        }
    },
    methods: {
        search: _.debounce(function (event) {
            window.location.href = "/browse?search=" + event.target.value;
        }, 1000),
    }
}
</script>

<style scoped>

</style>
